// ProjectsDashboard.js

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useProjects } from "../../context/ProjectsContext";
import ProjectCard from "./ProjectCard";
import { HiOutlinePlusCircle } from "react-icons/hi";
import { BsSearch } from "react-icons/bs";
import ConfirmModal from "../../Modals/ConfirmModal"; // Import ConfirmModal

function ProjectsDashboard() {
  const { projects, deleteProject } = useProjects();
  const [searchQuery, setSearchQuery] = useState("");
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [confirmAction, setConfirmAction] = useState(null);

  const filteredProjects = projects.filter((project) =>
    project.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleDeleteProject = (projectId) => {
    setConfirmMessage("Are you sure you want to delete this project?");
    setConfirmAction(() => async () => {
      try {
        await deleteProject(projectId);
        setIsConfirmModalOpen(false);
      } catch (error) {
        console.error("Error deleting project:", error);
      }
    });
    setIsConfirmModalOpen(true);
  };

  return (
    <div className="max-w-6xl mx-auto my-10 p-6 bg-white shadow-lg rounded-lg overflow-y-auto h-[85vh] scrollbar-none">
      <div className="flex flex-col sm:flex-row items-center justify-between mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4 sm:mb-0">
          Projects Dashboard
        </h1>
        <Link
          to="/projects/add"
          className="bg-blue-600 text-white flex items-center px-4 py-2 rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
        >
          <HiOutlinePlusCircle className="mr-2" />
          Add Project
        </Link>
      </div>
      <div className="relative mb-6">
        <input
          type="text"
          placeholder="Search projects..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full p-4 pl-12 bg-gray-100 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <BsSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredProjects.length > 0 ? (
          filteredProjects.map((project) => (
            <ProjectCard
              key={project.id}
              project={project}
              onDelete={handleDeleteProject}
              assignees={project.assignees}
            />
          ))
        ) : (
          <div className="col-span-full flex flex-col items-center text-center text-gray-500 mt-10">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-20 w-20 mb-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="8" y1="12" x2="16" y2="12"></line>
              <line x1="12" y1="8" x2="12" y2="16"></line>
            </svg>
            <p className="text-xl font-semibold">No projects found</p>
            <p className="mt-2">
              Start by adding a new project using the button above.
            </p>
          </div>
        )}
      </div>

      <ConfirmModal
        isOpen={isConfirmModalOpen}
        onRequestClose={() => setIsConfirmModalOpen(false)}
        onConfirm={confirmAction}
        message={confirmMessage}
      />
    </div>
  );
}

export default ProjectsDashboard;
